/**
 * <film-player>: plays the film only when the visitor asks for it.
 *
 * Until the click there is no YouTube or Vimeo iframe on the page, so nothing
 * loads from those services and they set no cookies. The click itself starts
 * the film with sound, which browsers allow because it follows a tap.
 */
if (!customElements.get('film-player')) {
  class FilmPlayer extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-film-play]')?.addEventListener('click', () => this.play(), { once: true });
    }

    play() {
      const template = this.querySelector('template');
      if (template) {
        this.replaceChildren(template.content.cloneNode(true));
        this.querySelector('video')?.play();
        return;
      }

      const { videoType, videoId, videoTitle } = this.dataset;
      let src = '';
      if (videoType === 'youtube') {
        src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
      } else if (videoType === 'vimeo') {
        src = `https://player.vimeo.com/video/${videoId}?autoplay=1&dnt=1`;
      }
      if (!src) return;

      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = videoTitle || '';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
      iframe.allowFullscreen = true;
      this.replaceChildren(iframe);
      iframe.focus();
    }
  }

  customElements.define('film-player', FilmPlayer);
}
